import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { apiClient } from "../../services/api";

/**
 * Reset Password — takes ?token=... from the reset email link.
 * Single-use token, 30-minute expiry, invalidates all sessions on success.
 */
export default function ResetPassword() {
  const [params] = useSearchParams();
  const [token] = useState(params.get("token") || "");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async () => {
    if (!token) return toast.error("Missing reset token");
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== pw2) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await apiClient.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      nav("/login", { replace: true });
    } catch (e) {
      const err = e?.response?.data?.detail?.error;
      if (err === "invalid_token") toast.error("This link is not valid.");
      else if (err === "expired") toast.error("This link has expired. Request a new one.");
      else if (err === "already_used") toast.error("This link has already been used.");
      else toast.error("Could not reset password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-4" style={{ background: "var(--canvas, #F4F3F1)" }}>
      <div className="w-full max-w-md bg-white rounded-[20px] p-6" data-testid="reset-password-page">
        <h1 style={{ fontFamily: "Barlow Condensed, sans-serif", fontWeight: 700, fontSize: 28 }}>Set a new password</h1>
        <input
          type="password"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder="New password (min 6 chars)"
          data-testid="reset-pw"
          className="w-full mt-4 h-12 px-3 rounded-[12px] border border-line bg-canvas2 outline-none"
        />
        <input
          type="password"
          value={pw2}
          onChange={(e) => setPw2(e.target.value)}
          placeholder="Confirm password"
          data-testid="reset-pw2"
          className="w-full mt-2 h-12 px-3 rounded-[12px] border border-line bg-canvas2 outline-none"
        />
        <button
          onClick={submit}
          disabled={busy}
          data-testid="reset-submit"
          className="w-full mt-3 h-12 rounded-pill disabled:opacity-50"
          style={{ background: "#00D4FF", color: "#000", borderRadius: 100, fontWeight: 700 }}
        >
          {busy ? "Updating…" : "Update password"}
        </button>
        <p style={{ fontSize: 11, color: "#8E8A84", marginTop: 10, textAlign: "center" }}>
          Signing in on other devices will be signed out.
        </p>
      </div>
    </div>
  );
}
